/**
 * Copyright Fitzba Technologies Inc. 2023
 *
 * Access record is a background process
 * that record acitivity on the app
 *
 * @author Yang
 * @version May 09, 2023
 */

import { useState, useEffect } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import { accessRecord } from "../services/api.service"
import { useSelector } from "react-redux"
import { getOSName } from '@utils/Helper'

export default function AccessRecord() {
  const [searchParams] = useSearchParams()
  // state for current url the user is in
  const [url, setUrl] = useState(null)
  // Redux state manager to get user info
  const userinfo = useSelector((state) => state.user.userinfo)
  // React router dom useLocation to get the current url path
  const location = useLocation()
  // if the user land on a new url path, set the url state to that new url path
  const pathname = location.pathname
  if (url !== pathname) setUrl(pathname)
  // async function that record user activity and upload it to the manager
  useEffect(() => {
    if (url == null) return
    const handleAccessRecord = async () => {
      const osName = getOSName()
      const ref = searchParams.get('ref')
      await accessRecord({
        url: url,
        user: userinfo?._id || null,
        osName: osName,
        ref: ref
      })
    }
    handleAccessRecord()
  }, [url, userinfo, searchParams])

  return null
}
